import * as layout from '../../../components/markLayout.module.css';
import { MarkSelect, MarkLabel } from '../../../components/MarkControls';
import React, { useId } from 'react';
import type { AuthorableDripExitReason } from '../../../types';
type Props = {
    value: AuthorableDripExitReason | undefined;
    onChange: (value: AuthorableDripExitReason) => void;
    disabled?: boolean;
};
const OPTIONS: {
    value: AuthorableDripExitReason;
    label: string;
}[] = [
    { value: 'SEGMENT_EXIT', label: 'Segment exit' },
    { value: 'COMPLETED', label: 'Completed' }
];
const ExitReasonSelect: React.FC<Props> = ({ value, onChange, disabled }) => {
    const selectId = useId();
    return (
        <div className={layout.field}>
            <MarkLabel htmlFor={selectId}>Exit reason</MarkLabel>
            <MarkSelect
                id={selectId}
                value={value ?? ''}
                onChange={(e) => onChange(e.currentTarget.value as AuthorableDripExitReason)}
                disabled={disabled}
            >
                <option value="" disabled>
                    Select reason
                </option>
                {OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>
                        {o.label}
                    </option>
                ))}
            </MarkSelect>
        </div>
    );
};
export default ExitReasonSelect;
